import { Box, Typography } from "@mui/material";
import { t } from "i18next";
import React from "react";
import { Link, useLocation } from "react-router-dom";

const NAVLINKS = [
  {
    id: 1,
    label: "eazistores",
    href: "/",
  },
  {
    id: 2,
    label: "cleaningServices",
    href: "/cleaning-services",
  },
  // {
  //   id: 3,
  //   label: "Car Services",
  //   href: "/car-services",
  // },
];

const NavLinks = () => {
  const location = useLocation();

  return (
    <Box
      display={"flex"}
      flexDirection={{ xs: "column", md: "row" }}
      alignItems={"flex-start"}
    >
      {NAVLINKS.map((link) => (
        <Box
          key={link.id}
          component={Link}
          to={link.href}
          borderRadius={"25px"}
          fontWeight={500}
          sx={{
            cursor: "pointer",
            textDecoration: "none",
            transition: "all 0.2s ease-in-out",
            "&:hover": {
              backgroundColor: "#f5f5f5",
            },
          }}
        >
          <Typography
            noWrap
            py={1}
            px={2}
            variant="body1"
            fontFamily="Poppins, sans-serif"
            color={location.pathname === link.href ? "primary.main" : "#757575"}
            textTransform={"capitalize"}
          >
            {t(link.label)}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default NavLinks;
